import { useMemo, useState } from 'react';
var generateEmbedScript = function (fileName) {
    return "<script src=\"path_to_the_file/".concat(fileName, "\" strategy=\"afterInteractive\"></script>");
};
var generateViewJobPostingScript = function (framework, config, themeData, componentName) {
    var kebabCaseComponentName = componentName.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    var jobPostingScript = "\nfunction render".concat(componentName, "() {\n  const theme = ").concat(JSON.stringify(themeData, null, 4), "\n  const config = ").concat(JSON.stringify(config, null, 4), ";\n  ").concat(componentName, "({elementId:\"").concat(kebabCaseComponentName, "-widget\", config, theme});\n}\nif (\n  document.readyState === \"complete\" ||\n  document.readyState === \"interactive\"\n) {\n  render").concat(componentName, "();\n} else {\n  document.addEventListener(\"DOMContentLoaded\", render").concat(componentName, ");\n}\n  ");
    switch (framework) {
        case 'React':
            return "\nimport { useEffect } from 'react';\n\nconst useView".concat(componentName, " = () => {\n  useEffect(() => {\n\n    const script = document.createElement('script');\n  \n    script.innerHTML = `").concat(jobPostingScript, "`;\n    \n    document.body.appendChild(script);\n  \n    return () => {\n      document.body.removeChild(script);\n    }\n  }, []);\n};\n\nexport default useView").concat(componentName, ";\n      ");
        case 'Next.js':
            return "\n    \"use client\";\n    import Script from 'next/script';\n\n    const ".concat(componentName, "Component = () => (\n      <>\n        <div id=\"").concat(kebabCaseComponentName, "-widget\"></div>\n        <Script id=\"job-posting\" strategy=\"lazyOnload\">\n      {`").concat(jobPostingScript, "`}\n        </Script>\n      </>\n    );\n\n    export default ").concat(componentName, "Component;\n      ");
        case 'Angular':
            return "\nimport { Component, OnInit } from '@angular/core';\n\n@Component({\n  selector: 'app-job-posting',\n  template: '<div id=\"".concat(kebabCaseComponentName, "-widget\"></div>'\n})\nexport class ").concat(componentName, "Component implements OnInit {\n  ngOnInit() {\n    ").concat(jobPostingScript, "\n  }\n}\n      ");
        default:
            return "\n<div id=\"".concat(kebabCaseComponentName, "-widget\"></div>\n<script>\n  ").concat(jobPostingScript, "\n</script>\n      ");
    }
};
export var useGeneratedScripts = function (_a) {
    var scriptConfig = _a.scriptConfig, themeConfig = _a.themeConfig, setIsScriptGenerated = _a.setIsScriptGenerated, fileInfo = _a.fileInfo, _b = _a.componentName, componentName = _b === void 0 ? 'JobPosting' : _b;
    var _c = useState([]), generatedScripts = _c[0], setGeneratedScripts = _c[1];
    var _d = useMemo(function () {
        if (fileInfo) {
            return fileInfo;
        }
        return {
            fileName: 'job-posting.bundle.js',
            fileUrl: '/job-posting.bundle.js',
        };
    }, [fileInfo]), fileName = _d.fileName, fileUrl = _d.fileUrl;
    var handleSubmit = function (e) {
        e.preventDefault();
        var formattedComponentName = componentName
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            .replace(/\b\w/g, function (char) { return char.toUpperCase(); });
        var scripts = [
            {
                title: "Download the scripts and move them to your project's code",
                file: {
                    fileName: fileName,
                    fileUrl: fileUrl,
                },
            },
            {
                script: generateEmbedScript(fileName),
                title: "Embed ".concat(formattedComponentName, " into the app."),
                description: 'Copy and paste the following code in your body tag of html code to inject the script.',
                note: 'Replace path_to_the_file with your file path.',
            },
            {
                script: [
                    {
                        framework: 'HTML',
                        script: generateViewJobPostingScript('HTML', scriptConfig, themeConfig, componentName),
                    },
                    {
                        framework: 'React',
                        script: generateViewJobPostingScript('React', scriptConfig, themeConfig, componentName),
                    },
                    {
                        framework: 'Next.js',
                        script: generateViewJobPostingScript('Next.js', scriptConfig, themeConfig, componentName),
                    },
                    {
                        framework: 'Angular',
                        script: generateViewJobPostingScript('Angular', scriptConfig, themeConfig, componentName),
                    },
                ],
                title: "Integrate ".concat(formattedComponentName, " UI into your framework."),
                description: "Copy and Paste the following code where you want to launch the ".concat(formattedComponentName, " UI"),
                note: 'Make sure main script should available when you execute this code',
            },
        ];
        setGeneratedScripts(scripts);
        setIsScriptGenerated(true);
    };
    return {
        generatedScripts: generatedScripts,
        handleSubmit: handleSubmit,
        fileName: fileName,
        fileUrl: fileUrl,
    };
};
